export default __webpack_public_path__ + "static/media/sudoku.0714ee67.jpg";